export const getPurchaseOptionsEndpoint = (medicalServiceId: number) =>
    `/api/medicalservices/${medicalServiceId}/purchaseoptions`;
export const OCCUPATIONAL_MEDICINE_MEDICAL_SERVICES =
    '/api/medicalservices/occupational-medicine';
